<template>
  <p>
    404 Error - Page not found
  </p>
</template>
<script>
export default {
  name: 'NotFound'
};
</script>